// src/components/Dashboard.jsx
import { useEffect, useState } from "react";
import { db, collection, query, onSnapshot, orderBy } from "./firebase"; // Ajusta la ruta
import ConversationCard from "./ConversationCard";
import { Link } from "react-router-dom";

export default function Dashboard() {
    const [conversations, setConversations] = useState([]);

    useEffect(() => {
        // Ordenar por lastUpdate en orden descendente (más reciente primero)
        const q = query(
            collection(db, "activeUsersCarros"),
            orderBy("lastUpdate", "desc")
        );
        const unsubscribe = onSnapshot(q, (snapshot) => {
            const data = snapshot.docs.map((doc) => ({
                id: doc.id,
                ...doc.data(),
            }));
            setConversations(data);
        });
        return () => unsubscribe();
    }, []);

    return (
        <>
            {/* <Link to="/campaign" className="btn btn-primary mb-4">
                Nueva campaña
            </Link> */}
            <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-4">
                {conversations.map((conv) => (
                    <>
                        <ConversationCard key={conv.id} conversation={conv} />
                    </>
                ))}

            </div>
        </>
    );
}
